const initialState = {
    unitMetric:'SF'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case "SET_UNIT_METRIC":
            return {...state, unitMetric: action.unitMetric}
        default:
            return state;
    }
};